<form [formGroup]="form" (ngSubmit)="changePass()">
    <mat-card class="card-container">
        <div class="card-content">
            <mat-card-title>
                Cambiar contraseña
            </mat-card-title>
            <mat-form-field class="full-width">
                <input type="password" autocomplete="off" matInput placeholder="Ingrese su contraseña actual" formControlName="ActualPassword" autofocus required>
                <mat-error *ngIf="form.hasError('required', 'ActualPassword')">
                    Ingrese la contraseña actual
                </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width">
                <input type="password" autocomplete="off" matInput placeholder="Contraseña nueva" formControlName="NewPassword" required>
                <mat-error *ngIf="form.hasError('required', 'NewPassword')">
                    Ingrese la nueva contraseña
                </mat-error>
                <mat-error *ngIf="!form.hasError('required', 'NewPassword') && 
                    form.hasError('noValidPasswordFormat', 'NewPassword')">
                    La constraseña debe tener mínimo 8 caracteres, letras y números
                </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width">
                <input type="password" autocomplete="off" matInput placeholder="Confirma la contraseña nueva" formControlName="ConfirmPassword" [errorStateMatcher]="matcher" required>
                <mat-error *ngIf="form.hasError('required', 'ConfirmPassword')">
                    Ingrese la nueva contraseña
                </mat-error>
                <mat-error *ngIf="form.hasError('notSame')">
                    Las contraseñas no coinciden
                </mat-error>
            </mat-form-field>
            <div style="text-align:right">
                <button color="primary" *ngIf="!loading" mat-flat-button type="submit">CAMBIAR LA CONTRASEÑA</button>
                <mat-spinner [diameter]="20" *ngIf="loading"></mat-spinner>
            </div>
        </div>
    </mat-card>
</form>